import moment from 'moment-timezone';
import React, { useRef } from 'react';
import useHover from '@react-hook/hover';

import { getUnits } from '@metservicedev/ww-get-units/src/ww-get-units';

import DataDownloader from '../../components/DataDownloader';
import DataTableHorizontal from './DataTableComponentRender/DataTableHorizontal';
import DataTableVertical from './DataTableComponentRender/DataTableVertical';
import { RootComponent } from './DataTable.style';
import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { DataTableModel, DataTableModelImmutable } from './types';

const DEFAULT_TITLE = 'Date & Time';

const Title = ({ title = DEFAULT_TITLE }) => (
    <div>
        <div>{title}</div>
    </div>
);

const DataTable: React.FC<IWidgetBlockComponent<DataTableModel | DataTableModelImmutable>> = ({ widgetModel, isLoading }) => {
    if (!widgetModel || isLoading) {
        return null;
    }

    const ref = useRef(null);
    const isHovering = useHover(ref);
    const model = (widgetModel as DataTableModelImmutable).toJS?.() || widgetModel;
    const { datasets, time, title, vertical, settings, databilities, ...rest } = model;

    const reportTime = time ? moment(time.iso8601).tz(time.timezone) : null;
    const TableComponent = vertical ? DataTableVertical : DataTableHorizontal;

    const tableTitle = <Title title={title ? title : DEFAULT_TITLE} />;

    const databilityToUnit = getUnits({
        databilityIds: model.databilities.map((d) => d.id),
        settings,
        type: 'dataTable',
    });

    return (
        <RootComponent ref={ref}>
            {settings.canDownload && isHovering && (
                <DataDownloader
                    datasetsWithData={datasets}
                    databilities={databilities}
                    databilityToUnit={databilityToUnit}
                    timezone={time?.timezone}
                    zipName='data-table'
                />
            )}
            <TableComponent {...rest} databilities={databilities} datasets={datasets} reportTime={reportTime} title={tableTitle} />
        </RootComponent>
    );
};

export default DataTable;
